/** Line icon of a small arched bridge, shaped like a lucide icon so the nav can render it the same way. */
export default function BridgeNavIcon({ size = 24, strokeWidth = 2 }: { size?: number; strokeWidth?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2 17q10-11 20 0" />
      <path d="M2 17h20" />
      <path d="M7 12.6V17M12 10.5V17M17 12.6V17" />
    </svg>
  );
}
